/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Profile__SubscriptionInputs */

const en_profile__subscription = /** @type {(inputs: Profile__SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} account`)
};

/**
* | output |
* | --- |
* | "{type} account" |
*
* @param {Profile__SubscriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const profile__subscription = /** @type {((inputs: Profile__SubscriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile__SubscriptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_profile__subscription(inputs)
});